//Global imports
import './main';
import './functions';
import './messages';

//HTML elements
import './html-elements/input'
import './html-elements/form-validation'
import './html-elements/switch'
import './html-elements/select'
import './html-elements/radio'
import './html-elements/modal'
import './html-elements/select-bar'
import './html-elements/ajax-list'
import './html-elements/ajax-list-csv'

//Page elements
import './page-elements/aside'
import './page-elements/user'

//Pages
import {initLogin} from "./pages/login";
import {initSettings} from "./pages/settings";
import {initStat} from "./pages/stat";

//Page router
const routes = {
    'login': initLogin,
    'settings': initSettings,
    'stat': initStat,
};

function runRouter() {
    const currentPage = document.body.dataset.page;
    if (routes[currentPage]) routes[currentPage]();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRouter);
} else {
    runRouter();
}